var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"point",style:({ left: _vm.coordinate.coordX(_vm.lng) + 'px', top: _vm.coordinate.coordY(_vm.lat) + 'px' })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }